import { FiCheck, FiAlertCircle } from "react-icons/fi"

// Step navigation for the EP1001 form (SCRUM-55), modelled on the left
// sidebar of the real EPO "Online-Einreichung 2.0" tool: the four
// content sections, freely navigable, with a red marker on the ones
// that are still incomplete.

export type PatentFormStep = {
  key: string
  label: string
  complete: boolean
}

export default function PatentFormStepper({
  steps,
  current,
  onSelect,
  disabled = false
}: {
  steps: PatentFormStep[]
  current: number
  onSelect: (index: number) => void
  disabled?: boolean
}) {
  return (
    <nav className="flex flex-wrap items-stretch gap-2">
      {steps.map((step, index) => {
        const active = index === current

        return (
          <button
            key={step.key}
            type="button"
            onClick={() => !disabled && onSelect(index)}
            disabled={disabled}
            className={`flex flex-1 items-center gap-2.5 rounded-xl border px-3 py-2.5 text-left text-sm transition ${
              active
                ? "border-dantzBlue bg-blue-50 text-dantzBlue"
                : "border-gray-200 bg-white text-gray-600 hover:border-gray-300"
            } ${disabled ? "cursor-not-allowed opacity-60" : ""}`}
          >
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${
                step.complete
                  ? "bg-green-100 text-green-700"
                  : active
                    ? "bg-dantzBlue text-white"
                    : "bg-gray-100 text-gray-500"
              }`}
            >
              {step.complete ? <FiCheck size={14} /> : index + 1}
            </span>

            <span className="min-w-0 flex-1">
              <span className="block text-[10px] font-medium uppercase tracking-wide text-gray-400">
                Step {index + 1}
              </span>
              <span className="block truncate font-medium">{step.label}</span>
            </span>

            {!step.complete && !active && (
              <FiAlertCircle size={15} className="shrink-0 text-red-500" />
            )}
          </button>
        )
      })}
    </nav>
  )
}
